export const GET_WISHLIST_ITEMS = 'GET_WISHLIST_ITEMS';
export const GET_WISHLIST_ITEMS_SUCCESS = 'GET_WISHLIST_ITEMS_SUCCESS';
export const GET_WISHLIST_ITEMS_ERROR = 'GET_WISHLIST_ITEMS_ERROR';
export const RESET_WISHLIST_ITEMS = 'RESET_WISHLIST_ITEMS';
export const GET_WISHLIST_ITEMS_DELAYED = 'GET_WISHLIST_ITEMS_DELAYED';

export const SELECT_WISHLIST_ITEM = 'SELECT_WISHLIST_ITEM';
export const DESELECT_WISHLIST_ITEM = 'DESELECT_WISHLIST_ITEM';
export const DESELECT_MANY_WISHLIST_ITEMS = 'DESELECT_MANY_WISHLIST_ITEMS';
export const RESET_WISHLIST_ITEMS_ACTIONS = 'RESET_WISHLIST_ITEMS_ACTIONS';

export const OPEN_WISHLIST_ITEM = 'OPEN_WISHLIST_ITEM';
export const CLOSE_WISHLIST_ITEM = 'CLOSE_WISHLIST_ITEM';

export const SET_WISHLIST_ITEMS_FILTERS = 'SET_WISHLIST_ITEMS_FILTERS';
export const SET_WISHLIST_ITEMS_QUERY = 'SET_WISHLIST_ITEMS_QUERY';
export const UPDATE_WISHLIST_ITEMS = 'UPDATE_WISHLIST_ITEMS';
